import { i as isObject, $, S as Swiper, N as Navigation, P as Pagination } from "./pagination.chunk.js";
function Thumb({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let initialized = false;
  let swiperCreated = false;
  swiper.thumbs = {
    swiper: null
  };
  function onThumbClick() {
    const thumbsSwiper2 = swiper.thumbs.swiper;
    if (!thumbsSwiper2 || thumbsSwiper2.destroyed)
      return;
    const clickedIndex = thumbsSwiper2.clickedIndex;
    const clickedSlide = thumbsSwiper2.clickedSlide;
    if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass))
      return;
    if (typeof clickedIndex === "undefined" || clickedIndex === null)
      return;
    let slideToIndex;
    if (thumbsSwiper2.params.loop) {
      slideToIndex = parseInt($(thumbsSwiper2.clickedSlide).attr("data-swiper-slide-index"), 10);
    } else {
      slideToIndex = clickedIndex;
    }
    if (swiper.params.loop) {
      let currentIndex = swiper.activeIndex;
      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix();
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }
      const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      if (typeof prevIndex === "undefined")
        slideToIndex = nextIndex;
      else if (typeof nextIndex === "undefined")
        slideToIndex = prevIndex;
      else if (nextIndex - currentIndex < currentIndex - prevIndex)
        slideToIndex = nextIndex;
      else
        slideToIndex = prevIndex;
    }
    swiper.slideTo(slideToIndex);
  }
  function init() {
    const {
      thumbs: thumbsParams
    } = swiper.params;
    if (initialized)
      return false;
    initialized = true;
    const SwiperClass = swiper.constructor;
    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if (isObject(thumbsParams.swiper)) {
      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }
    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on("tap", onThumbClick);
    return true;
  }
  function update(initial) {
    const thumbsSwiper2 = swiper.thumbs.swiper;
    if (!thumbsSwiper2 || thumbsSwiper2.destroyed)
      return;
    const slidesPerView = thumbsSwiper2.params.slidesPerView === "auto" ? thumbsSwiper2.slidesPerViewDynamic() : thumbsSwiper2.params.slidesPerView;
    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }
    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }
    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper2.slides.removeClass(thumbActiveClass);
    if (thumbsSwiper2.params.loop || thumbsSwiper2.params.virtual && thumbsSwiper2.params.virtual.enabled) {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper2.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
      }
    } else {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper2.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
      }
    }
    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper2.params.loop;
    if (swiper.realIndex !== thumbsSwiper2.realIndex || useOffset) {
      let currentThumbsIndex = thumbsSwiper2.activeIndex;
      let newThumbsIndex;
      let direction;
      if (thumbsSwiper2.params.loop) {
        if (thumbsSwiper2.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper2.params.slideDuplicateClass)) {
          thumbsSwiper2.loopFix();
          thumbsSwiper2._clientLeft = thumbsSwiper2.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper2.activeIndex;
        }
        const prevThumbsIndex = thumbsSwiper2.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
        const nextThumbsIndex = thumbsSwiper2.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
        if (typeof prevThumbsIndex === "undefined") {
          newThumbsIndex = nextThumbsIndex;
        } else if (typeof nextThumbsIndex === "undefined") {
          newThumbsIndex = prevThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = thumbsSwiper2.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = nextThumbsIndex;
        } else {
          newThumbsIndex = prevThumbsIndex;
        }
        direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
      }
      if (useOffset) {
        newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
      }
      if (thumbsSwiper2.visibleSlidesIndexes && thumbsSwiper2.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper2.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper2.params.slidesPerGroup === 1)
          ;
        thumbsSwiper2.slideTo(newThumbsIndex, initial ? 0 : void 0);
      }
    }
  }
  on("beforeInit", () => {
    const {
      thumbs
    } = swiper.params;
    if (!thumbs || !thumbs.swiper)
      return;
    init();
    update(true);
  });
  on("slideChange update resize observerUpdate", () => {
    update();
  });
  on("setTransition", (_s, duration) => {
    const thumbsSwiper2 = swiper.thumbs.swiper;
    if (!thumbsSwiper2 || thumbsSwiper2.destroyed)
      return;
    thumbsSwiper2.setTransition(duration);
  });
  on("beforeDestroy", () => {
    const thumbsSwiper2 = swiper.thumbs.swiper;
    if (!thumbsSwiper2 || thumbsSwiper2.destroyed)
      return;
    if (swiperCreated) {
      thumbsSwiper2.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init,
    update
  });
}
let productMainSliderThumbNails;
const thumbsSwiper = document.querySelector("#productMainSliderThumbs");
if (thumbsSwiper) {
  productMainSliderThumbNails = new Swiper("#productMainSliderThumbs", {
    direction: "vertical",
    spaceBetween: 16,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    on: {
      init: function() {
        thumbsSwiper ? thumbsSwiper.style.display = "block" : null;
      }
    }
  });
  if (productMainSliderThumbNails.initialized) {
    thumbsSwiper.style.display = "block";
  } else {
    thumbsSwiper.style.display = "none";
  }
}

const productMainSlider = new Swiper("#productMainSlider", {
  modules: [Navigation, Pagination, Thumb],
  slidesPerView: 1,
  loop: true,
  speed: 500,
  observer: true,
  observeParents: true,
  preloadImages: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".swiper-button-next.productMainSlider-swiper-button-next",
    prevEl: ".swiper-button-prev.productMainSlider-swiper-button-prev",
    disabledClass: "swiper-button-disabled",
    lockClass: "swiper-button-unlocked"
  },
  pagination: {
    el: ".swiper-pagination.productMainSlider-swiper-pagination",
    clickable: true
  },
  thumbs: {
    swiper: document.querySelector("#productMainSliderThumbs") ? productMainSliderThumbNails : null
  },
  on: {
    init: function() {
      // Force unlock navigation buttons after initialization
      const nextButton = document.querySelector(".swiper-button-next.productMainSlider-swiper-button-next");
      const prevButton = document.querySelector(".swiper-button-prev.productMainSlider-swiper-button-prev");
      
      if (nextButton) nextButton.classList.remove("swiper-button-lock");
      if (prevButton) prevButton.classList.remove("swiper-button-lock");
      
      // Force update after initialization
      setTimeout(() => {
        this.update();
        this.updateSize();
        this.updateSlides();
      }, 10);
    },
    slideChange: function() {
      // Pause all videos first
      document.querySelectorAll('.product-video').forEach(video => {
        if (video.tagName === 'VIDEO') {
          video.pause();
        } else if (video.tagName === 'IFRAME') {
          try {
            const src = video.src;
            video.src = src;
          } catch (e) {}
        }
      });
      
      // Get current slide
      const activeSlide = this.slides[this.activeIndex];
      // Find video in active slide
      const activeVideo = activeSlide.querySelector('.product-video');
      
      if (activeVideo) {
        if (activeVideo.tagName === 'VIDEO') {
          console.log('Playing HTML video');
          activeVideo.muted = true; // Must be muted for autoplay
          activeVideo.currentTime = 0;
          const playPromise = activeVideo.play();
          if (playPromise !== undefined) {
            playPromise.catch(err => {
              console.error('Video play error:', err);
            });
          }
        } else if (activeVideo.tagName === 'IFRAME') {
          console.log('Setting up iframe video');
          try {
            let src = activeVideo.src;
            // Remove existing autoplay parameter if any
            src = src.replace(/&?autoplay=\d/g, '');
            // Add autoplay and mute parameters
            const separator = src.includes('?') ? '&' : '?';
            activeVideo.src = `${src}${separator}autoplay=1&mute=1`;
          } catch (e) {
            console.error('Iframe update error:', e);
          }
        }
      }
    }
  }
});

// Remove this separate event handler since we've integrated it directly into the Swiper config
// productMainSlider.on('slideChange', function () { ... });

// Force Swiper to update on window load and DOMContentLoaded
window.addEventListener('load', () => {
  setTimeout(() => {
    if (productMainSlider) {
      productMainSlider.update();
      productMainSlider.updateSize();
    }
  }, 100);
});

function addStickyClass() {
  var _a;
  let initialHeaderHeight = 0;
  const currentHeaderHeight = (_a = document.querySelector("header")) == null ? void 0 : _a.offsetHeight;
  const indentFromTop = currentHeaderHeight;
  const mainContent = document.querySelector(".js-sticky-swiper");
  if (initialHeaderHeight !== indentFromTop) {
    mainContent ? mainContent.style.top = indentFromTop + "px" : null;
    initialHeaderHeight = indentFromTop;
  }
}
addStickyClass();
window.addEventListener("resize", addStickyClass);
document.querySelectorAll(".jc-block-reviews").forEach((swiper) => {
  new Swiper(`#${swiper.id}`, {
    modules: [Pagination],
    slidesPerView: 1.1,
    spaceBetween: 16,
    pagination: {
      el: ".swiper-pagination"
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5
      }
    }
  });
});
document.querySelectorAll(".swiper-upsell-cards").forEach((swiper) => {
  new Swiper(`#${swiper.id}`, {
    modules: [Pagination],
    slidesPerView: 2,
    spaceBetween: 8,
    pagination: {
      el: ".swiper-upsell-cards-pagination",
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      900: {
        slidesPerView: 2.5
      }
    }
  });
});
